// removed by extract-text-webpack-plugin
module.exports = {"descriptionPlaceholder":"YdX6Z4bPfHUeSSb__t8TU","placeholderTitle":"g0Jg9C9p8ffssfjvY74Go","placeholderRow":"_3eL7UgQlQqr9nZrBroo_CX","descriptionColumn":"_7D0VQ52I169BC0c4eFKP2","mobile":"_3WO8DA2JWMv_YYcfcc_cjn","titleColumn":"tCUwkbB-HLM956TeLQdsY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/DescriptionPlaceholder/DescriptionPlaceholder.scss
// module id = 1720
// module chunks = 0